import { render } from '@wordpress/element';

import './style.scss';
import Style from './Style';
import SteppedContent from './SteppedContent';

// Stepped Content
document.addEventListener('DOMContentLoaded', () => {
	const allSteppedContent = document.querySelectorAll('.wp-block-stp-content');
	allSteppedContent.forEach(stpContent => {
		const { attributes, content } = JSON.parse(stpContent.dataset.props);

		render(<>
			<Style attributes={attributes} clientId={attributes.cId} />

			<SteppedContent attributes={attributes} content={content} clientId={attributes.cId} />
		</>, stpContent);

		stpContent?.removeAttribute('data-props');
	});
});